MatchCore.UI.StandardPrompt = function () {
    var _container = null;
    var _confirmAction = null;
    var _dismissAction = null;
    //var _content = null;
    var _effects = {
        autoShow: null,
        autoDismissIn: null,
        fadeIn: null,
        fadeOut: null
    };
    //var _onClosedDelegate = new MatchCore.Delegate();

    var render = function () {
        $jq(_container).wrapInner('<div class="promptContent"/>').prepend('<div class="close prompt_dismiss"><span>x</span></div>').addClass('standardPrompt');
        $jq.initBehavior(_container, 'MatchCore.UI.Site.ModalDialog', { autoShow: _effects.autoShow, autoCenter: true, fadeIn: _effects.fadeIn, fadeOut: _effects.fadeOut });
    };

    var parseMeta = function (options) {
        if (options) {
            if (options.moveOutOfHierarchy) {
                options.moveOutOfHierarchy = false;
                $jq(_container).attr("meta", JSON.stringify(options));
                $jq(_container).remove();
                $jq("body").append(_container);
            }
            if (options.fadeIn)
                _effects.fadeIn = options.fadeIn;

            if (options.fadeOut)
                _effects.fadeOut = options.fadeOut;

            if (options.autoDismissIn)
                _effects.autoDismissIn = options.autoDismissIn;

            if (options.autoShow)
                _effects.autoShow = options.autoShow;
        }
    };

    var wireupControls = function () {
        $jq('.prompt_dismiss', _container).click(function (event) {
            $jq('.handle, .password', _container).val('');
            //_onClosedDelegate.fireAndPreserve();
            if ($jq.browser.msie) {
                event.cancelBubble = true;
            } else {
                event.stopPropagation();
            }
            event.preventDefault();
            self.dismiss();
        });

        $jq('.prompt_confirm', _container).click(function (event) {
            if ($jq.browser.msie) {
                event.cancelBubble = true;
            } else {
                event.stopPropagation();
            }
            event.preventDefault();
            self.confirm();
        });
    };

    var self = {
        init: function (opts) {
            _container = opts.container;

            if (opts.meta != undefined) {
                parseMeta(opts.meta);
            }

            if ($jq('.promptContent', _container).length < 1) {
                render();
            }

            wireupControls();
        },

        invoke: function (opts) {
            if (opts) {
                _confirmAction = (opts.confirm) ? opts.confirm : null;
                _dismissAction = (opts.dismiss) ? opts.dismiss : null;
            }
            else {
                _confirmAction = null;
                _dismissAction = null;
            }

            if (_effects.autoDismissIn) {
                setTimeout(function () {
                    $jq(_container).dismissClientModal();
                }, _effects.autoDismissIn);
            }
            $jq(_container).showClientModal();
        },

        dismiss: function () {
            $jq(_container).dismissClientModal();
            if (_dismissAction != null)
                _dismissAction();
        },

        confirm: function () {
            $jq(_container).dismissClientModal();
            if (_confirmAction != null)
                _confirmAction();
        }//,
        //on_ShowPrompt: function (opts) {
        //    this.invoke(opts);
        //},
        //on_setDismissAction: function (action) {
        //    _onClosedDelegate = null;
        //    _onClosedDelegate = new MatchCore.Delegate();
        //    _onClosedDelegate.add(action);
        //},
        //on_dismiss: function () {
        //    $jq(_container).dismissClientModal();

        //    if (_dismissAction != null)
        //        _dismissAction();
        //}
    };

    return self;
};

MatchCore.UI.Site.LoginPrompt = function () {
	var _container = null;
	var _successAction = null;
	var _failAction = null;
	var _effects = {
		fadeIn: null,
		fadeOut: null
	};

    var render = function () {
		$jq.initBehavior(_container, 'MatchCore.UI.StandardPrompt', { fadeIn: _effects.fadeIn, fadeOut: _effects.fadeOut });
	};

    var wireupControls = function () {
        $jq('.login_confirm', _container).click(function (event) {
            if ($jq.browser.msie) {
				event.cancelBubble = true;
			} else {
				event.stopPropagation();
			}
			event.preventDefault();
			self.confirm();
		});
	};

    var promptError = function (msg) {
		$jq('.errors', _container).html(msg);
		$jq('.errors', _container).show();
	};

	var callLoginService = function(handle, password) {
		ensureSession(function() {
			var url = '/Membership/Login/';

			$jq.ajax({
				type: "POST",
				url: url,
				data: {
					'handle': handle,
					'password': password
				},
				dataType: "json",
                success: function (response) {
					if (response.success != undefined) {
					    if (!response.success) {
					        var responseCode = response.reason;
					        if (typeof displayErrorMessage != 'undefined') {
					            responseCode = displayErrorMessage(responseCode);
					        }

					        promptError(responseCode);
							return;
						}

                        $jq(_container).behavior('MatchCore.UI.StandardPrompt', function (dialog) {
							dialog.dismiss();
						});

						if (response.uid != undefined) {
							//compare previous uid to logged in
							var oldUid = ($jq('#cuid').val().length > 0) ? parseInt($jq('#cuid').val()) : 0;

							if (parseInt(response.uid) != oldUid) {
								//refresh the page
								window.location.reload(true);
								return;
							}
						}
                        if (_successAction) {
                            _successAction(response);
                        }

						return;
					}

					promptError(MatchCore.UI.Site.Translate.getTranslation('MatchContent.Account.AccountSettings.LoginFailed'));
					_failAction(response);
				},
                error: function (response) {
                    promptError(MatchCore.UI.Site.Translate.getTranslation('MatchContent.Account.AccountSettings.LoginFailed'));
					_failAction(response);
				}
			});
		});
	};

    var ensureSession = function (callback) {
		$jq.ajax({
			type: "GET",
			url: '/Membership/EnsureSession/',
			success: function(response) {
				callback();
			}
		});
	};

	var self = {
        init: function (opts) {
			_container = opts.container;
			render();
			wireupControls();
		},

        invoke: function (opts) {
			$jq('.errors', _container).hide();
			
			if (opts) {
				_successAction = (opts.success) ? opts.success : null;
				_failAction = (opts.fail) ? opts.fail : null;
			}
			else {
				_successAction = null;
				_failAction = null;
			}

			$jq(_container).prompt();
		},

        confirm: function () {
			$jq('.errors', _container).hide();
			
			var handleField = $jq('*[name="handle"]', _container);
			var passwordField = $jq('*[name="password"]', _container);

			var handle = handleField.val();
			var password = passwordField.val();

			if (handle == null || handle.length <= 0) {
			    if (typeof handleNullErrorMsg == 'undefined') {
			        handleNullErrorMsg = MatchCore.UI.Site.Translate.getTranslation('MatchContent.Account.AccountSettings.EnterUserName');
			    }
			    promptError(handleNullErrorMsg);
				return false;
			}

			if (password == null || password.length <= 0) {
			    if (typeof passwordNullErrorMsg == 'undefined') {
			        passwordNullErrorMsg = MatchCore.UI.Site.Translate.getTranslation('MatchContent.Error.ErrorMessages.ErrorPasswordMissing');
			    }
			    promptError(passwordNullErrorMsg);
				return false;
			}
			callLoginService(handle, password);
		}
	};

	return self;
};

MatchCore.UI.Site.MessageSummary = function () {
	var _container = null;

	var self = {
        init: function (opts) {
			_container = opts.container;
		},

        clear: function () {

		},

        yield: function (messages) {
			
		}
	};
	return self;
};

MatchCore.UI.Elements = function () {
	var _loginLoaded = false;

    var ensureLoginLoaded = function (callback) {
		if (!_loginLoaded) {
			var url = '/Membership/LoginPanel/';

			$jq.ajax({
				type: "GET",
				url: url,
                success: function (response) {
					$jq('BODY').append('<div id="globalLogin"></div>');
					$jq('#globalLogin').hide();
					$jq('#globalLogin').append(response);

					$jq.initBehavior($jq('#globalLogin'), 'MatchCore.UI.Site.LoginPrompt', null);
					_loginLoaded = true;
					callback();
				}
			});
		}
		else {
			callback();
		}
	};

    var self = {
        loginPrompt: function(opts) {
            ensureLoginLoaded(function() {
                $jq('#globalLogin').behavior('MatchCore.UI.Site.LoginPrompt', function(login) {
                    login.invoke(opts);
                });
            });
        },

        ensureLoggedInBefore: function(callback) {
            $jq.ajax({
                type: "GET",
                url: MatchCore.Application.resolveUrl('~/Membership/IsLoggedIn/'),
                success: function(response) {
                    if (response == "true" || response == true) {
                        callback();
                    } else {
                        self.loginPrompt({ success: callback });
                    }
                }
            });
        }
    };

	return self;
}();                          	//static class

jQuery.fn.prompt = function(opts) {
	return this.each(function() {
		//check for attached behavior
        jQuery(this).behavior('MatchCore.UI.StandardPrompt', function (instance) {
			instance.invoke(opts);
		});
	});
};

